






















import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import ComboBox from './ComboBox.vue'
import EventsComboBoxItem from './EventsComboBoxItem.vue'

const REQUEST_URL_BASIS = `${location.origin}/watchout/api/events`
const SEARCH_PHRASE_PARAMETER_KEY = 'q'
const REQUEST_TIMEOUT_DURATION = 400

export default Vue.extend({
  props: {
    value: Object,
    searchPhrase: String,
    selectedEventIdentifier: Number
  },
  components: {
    ComboBox,
    EventsComboBoxItem
  },
  data () {
    return {
      events: [] as any[],
      requestTimeoutIdentifier: undefined as undefined | number,
      multiselectComponentData: undefined as any,
      searchRequested: undefined as undefined | boolean
    }
  },
  computed: {
    selectedItemLabel () : string {
      return this.label(this.value)
    }
  },
  mounted () {
    this.multiselectComponentData = ((this.$refs.comboBox as InstanceType<typeof ComboBox>).$refs.multiselect as Multiselect).$data
    this.multiselectComponentData.search = this.searchPhrase || ''
    this.search()
  },
  watch: {
    selectedEventIdentifier (selectedId) {
      if (selectedId && !this.events.find(event => event['id'] === selectedId)) {
        this.search()
        return
      }
      this.$nextTick(() => {
        if (!this.searchRequested) {
          if (this.selectedEventIdentifier) {
            this.$emit('input', this.events.find(event => event['id'] === this.selectedEventIdentifier) || this.getDefaultEvent())
          } else {
            this.$emit('input', this.getDefaultEvent())
          }
        }
      })
    },
    events () {
      if (this.selectedEventIdentifier) {
        this.$emit('input', this.events.find(event => event['id'] === this.selectedEventIdentifier) || this.getDefaultEvent())
      } else {
        this.$emit('input', this.getDefaultEvent())
      }
    },
    searchPhrase () {
      this.multiselectComponentData.search = this.searchPhrase || ''
      this.search()
    }
  },
  methods: {
    getDefaultEvent (): any | null {
      const oneHourAgo = Date.now() - 60 * 60 * 1000
      const eligibleEvents = this.events.filter(event => {
        const fromDate = event['from_date']
        return fromDate && new Date(fromDate).getTime() >= oneHourAgo
      })
      if (!eligibleEvents.length) {
        return null
      }
      return eligibleEvents.reduce((best, event) =>
        (event['priority'] || 0) > (best['priority'] || 0) ? event : best
      )
    },
    label (option: any) {
      return option && `${option['id']}, ${option['name']}, ${option['from_date']}, ${option['to_date']}`
    },
    search () {
      if(this.$store.state.isLunchMap){
        this.events = [];
        return;
      }
      this.searchRequested = true
      clearTimeout(this.requestTimeoutIdentifier)
      this.requestTimeoutIdentifier = setTimeout(() => {
        const requestURL = new URL(REQUEST_URL_BASIS)
        this.searchPhrase && requestURL.searchParams.set(SEARCH_PHRASE_PARAMETER_KEY, this.searchPhrase)
        this.selectedEventIdentifier && requestURL.searchParams.set('id', String(this.selectedEventIdentifier))
        fetch(requestURL.toString()).then(response => response.json()).then(data => {
          if (data['count']) {
            this.events = data['results']
          } else {
            this.events = []
          }
        }).finally(() => this.searchRequested = false)
      }, REQUEST_TIMEOUT_DURATION)
    }
  }
})
